/**
 * Column widths for a `fitAllColumns` list (the legacy XAF ListView look: every
 * column visible, no horizontal scroll).
 *
 * WHY PERCENTAGES — `table-layout: fixed` does NOT scale px column widths down to
 * the table. The browser honours them literally, so a column set that sums wider
 * than its container still overflows: 1452px of columns renders a 1482px table
 * inside a 1000px box. That is what made ICP-MS Mass Pick (1360px of columns)
 * scroll sideways while its config claimed to fit. A percentage resolves against
 * the table width instead, so the columns scale down and keep their proportions.
 *
 * For a set that sums NARROWER than the container the two are identical — the
 * surplus is distributed proportionally either way — so switching an existing
 * `fitAllColumns` list to percentages does not move a single pixel.
 */

/** Total of every width that shares the table, leading cells included. */
export function fitTotal(leadWidths: readonly number[], columnWidths: readonly number[]): number {
  const sum = [...leadWidths, ...columnWidths].reduce((a, b) => a + b, 0);
  // Guards a caller with no columns yet (first render) against a divide-by-zero
  // that would emit `NaN%` and collapse the header row.
  return sum > 0 ? sum : 1;
}

/** One column's share of the table, as a CSS percentage. */
export function fitPct(width: number, total: number): string {
  return `${((width / (total > 0 ? total : 1)) * 100).toFixed(4)}%`;
}
